import { Controller } from '@hotwired/stimulus';

// 「例をクリックで追加」チップ。クリックしたテキストを、同じ行コンテナ内の
// 最初の空テキスト入力へ入れる(旧 paybook.js の .pay-ex a ハンドラ)。
export default class extends Controller {
  fill(event) {
    event.preventDefault();
    const text = event.target.textContent;
    const container = event.target.closest('.fld, td');
    if (!container) return;
    const inputs = container.querySelectorAll('input[type=text]');
    for (const input of inputs) {
      if (input.value === '') {
        input.value = text;
        break;
      }
    }
  }
}
